// extracted by mini-css-extract-plugin
var _1 = "academicDept-module_academic_difference_tbody_tr_td_certification__xKxyLF";
var _2 = "academicDept-module_academic_difference_tbody_tr_td_certification_arrow__XZb7kS";
export { _1 as "academic_difference_tbody_tr_td_certification", _2 as "academic_difference_tbody_tr_td_certification_arrow" }
